import { render, staticRenderFns } from "./TopicCardGrid.vue?vue&type=template&id=2c920ca4"
import script from "./TopicCardGrid.vue?vue&type=script&lang=js"
export * from "./TopicCardGrid.vue?vue&type=script&lang=js"
import style0 from "./TopicCardGrid.vue?vue&type=style&index=0&id=2c920ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports